export default __webpack_public_path__ + "static/page-layout.dark-a84cd64f5b58125bd648447affa9812e92b8ecee5855b79b02bee37cef6fddc9.png";